<template>
  <el-dialog
      title="查看用户"
      :visible.sync="dialogVisible"
      width="30%">
    <el-form ref="form" :model="form" label-width="80px" label-position="left" size="small" disabled>
      <div class="itemWarp">
        <el-form-item label="姓名" style="width: 45%">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="手机号" style="width: 45%">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
      </div>

      <div class="itemWarp">
        <el-form-item label="性别" style="width: 45%">
          <el-input v-model="form.sex"></el-input>
        </el-form-item>

        <el-form-item label="人员类别" style="width: 45%">
          <el-input v-model="form.isExternal"></el-input>
        </el-form-item>
      </div>

      <div class="itemWarp">
        <el-form-item label="所在部门" style="width: 100%" v-if="type ==='interior'">
          <el-input v-model="form.department"></el-input>
        </el-form-item>
         <el-form-item label="所在公司" style="width: 100%" v-else>
          <el-input v-model="form.department"></el-input>
        </el-form-item>
      </div>

      <div class="itemWarp">
        <el-form-item label="账号状态" style="width: 30%">
          <el-input v-model="form.isEnable"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false" type="primary" size="small">关 闭</el-button>
    <!-- <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button> -->
  </span>
  </el-dialog>
</template>

<script>
import request from '@/xgzdService/prjMember-service'
export default {
  name:'personDetail',

  props:['type'],

  data () {
    return {
      dialogVisible:false,
      form:{
        name:'',
        phone:'',
        department:'',
        isExternal:'',
        sex:'',
        isEnable:''
      }
    }
  },

  methods : {
    queryDetail ({ roleStaffId }) {
      const requestType = this.type === 'interior' ? 'queryInteriorPersonDetail' : 'queryExternalPersonDetail'
      request[requestType](roleStaffId)
      .then(res => {
        if (res.result === '0') {
          res.data = res.data || {}
          const {name,phone,department,isExternal,sex,isEnable,company} = res.data
          this.form.name = name
          this.form.phone = phone
          this.form.department = department || company
          this.form.isExternal = isExternal ? '外部' : '内部'
          this.form.sex = sex ? sex === '2' ? '女' : '男' : ''
          this.form.isEnable = isEnable == '1' ?  '启用' : '禁用'
        }
      })
      .catch(e => {
        this.$message.warning(e.message || '查询详情失败')
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  /deep/ .el-form
           .itemWarp
             display flex
             align-items center
             justify-content space-between
</style>
